import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ExamAddressCreateRequest, ExamAddressesClient } from '../../../generated-client/generated-api-client';
import { Router } from '@angular/router';
import { ErrorProcessorService } from '../../../services/error-processor.service';
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-exam-address-new',
  templateUrl: './exam-address-new.component.html',
  styleUrls: ['./exam-address-new.component.sass'],
})
export class ExamAddressNewComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private client: ExamAddressesClient,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    this.titleService.setTitle('Vizsgahelyszín létrehozása');
  }

  ngOnInit(): void {}

  onSubmit(form: FormGroup): void {
    const request: ExamAddressCreateRequest = {
      city: form.get('city')?.value === '' ? null : form.get('city')?.value,
      postCode: form.get('postCode')?.value === '' ? null : form.get('postCode')?.value,
      line1: form.get('line1')?.value === '' ? null : form.get('line1')?.value,
      line2: form.get('line2')?.value === '' ? null : form.get('line2')?.value,
    };
    this.client.new(request).subscribe(
      next => {
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/exam-addresses']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
